import LoadingPlayer from "./LoadingPlayer";
import React, {memo} from "react";

const PlayerLoadingWrapper = ({loading, children, ...props}) => {
    if (loading)
        return <LoadingPlayer {...props}/>
    else return children;
}

export default memo(PlayerLoadingWrapper)